import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Customers from './Customers.js';
import DateSelector from './DateSelector.js';
import Trades from './Trades.js';
import Invoices from './Invoices.js';
import ExpensesSummary from './ExpensesSummary.js';
import ProfitSummary from './ProfitSummary.js';
import DMVSummary from './DMVSummary.js';
import FileBank from './FileBank.js';
import Paperwork from './Paperwork.js';
import SimpleTable from '../../components/SimpleTable.js';
import Header from '../../components/Header.js';
import firebase from '../../utilities/firebase.js';
import { getFunctions, httpsCallable } from "firebase/functions";
import history from '../../utilities/history.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { StateManager } from '../../utilities/stateManager.js'

import Preview from '../../components/Preview.js';
import moment from 'moment';
import TextLine from '../../components/TextLine.js';
import Check from '../../components/Check.js';
import Action from '../../components/Action.js';
import DateLine from '../../components/DateLine.js';
import StatusLine from '../../components/StatusLine.js';
import Dropdown from '../../components/Dropdown.js';
import RequestManager from '../../utilities/requestManager.js';

export default function Checkin(props) {
    const { car = {} } = props;
    const { stock } = car;
    let inspection = {...car.inspection, ...car} || {};

    const updater = (table, data) => {
      if (table === 'cars') {
        StateManager.updateCar(data);
      } else if (table === 'inspections') {
        StateManager.updateCar({ inspection: { ...(car.inspection || {}), ...data } });
      }
      return firebase.firestore().doc(`${table}/${stock}`).set(data, {merge: true});
    };

    const updateText = (id, value) => {
      let table = "checkins"
      if(id == "miles") table="cars";
      if(id == "color") table="cars";
      if(id == "vin") table="cars";
      if(id == "engine-type") table="cars";
      if(id == "interior-color") table="cars";
      if(id == "interior-material") table="cars";
      updater(table, {[id]: value, needsDAUpdate: true});
    }

    const fields = [
      "inspector", 
      "color",
      "miles",
      "vin",
      // "engine-type",
      // "interior-color",
      // "interior-material",
      // "has-power-brakes",
      // "has-power-steering",
      // "has-air-conditioning",
      // "inspection-date",
    ];



    return (
        <>
          <Typography variant={"h5"} align="left" style={{padding: 7}}>
            {formatTitle("inspection-data")}
          </Typography>
          {
            fields.map((field, i) => 
                <div style={{marginBottom: '3px'}}>
                    <TextLine id={field} data={inspection} onChange={updateText} label={StateManager.formatTitle(field)} />
                </div>
            )
          }
          {
            Object.values(sections).map((section, i) => {
              const {title, points} = section;
              const components = points.map((point, i) => 
                <div style={{marginBottom: '3px'}}>
                    <StatusLine id={point} data={inspection} label={StateManager.formatTitle(point)} updater={updater} />
                </div>
              )

              const notesId = `${title.toLowerCase().replace(/ /g, '-')}-notes`;

              return (
                <div style={{paddingTop: 10}}>
                  <Typography variant={"h5"} align="left" style={{padding: 7}}>
                    {formatTitle(title)}
                  </Typography>
                  {components}
                  <div style={{marginTop: 10, marginBottom: 20}}>
                    <TextLine 
                      id={notesId}
                      data={inspection}
                      onChange={(id, value) => updater('inspections', {[id]: value})}
                      label={`${formatTitle(title)} Notes`}
                      multiline={true}
                      rows={3}
                    />
                  </div>
                </div>
              )
            })
          }
        </>
    );
}

const formatTitle = raw => {
  raw = raw.split('-');
  raw = raw.join(' ');
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}



const sections = [
    {
      "title": "Exterior",
      "points": [
        "Paint quality (scratches, dings, fading, bubbling,etc.)",
        "Tire quality - record date (tread depth, sidewall condition, cracks, etc.)",
        "Headlights",
        "Rear lights",
        "Turn signals",
        "Side marker lights",
        "Trunk (rust, holes, etc.)",
        "Bumpers (rust or pivots)",
        "Trim (Scratches or pivots)"
      ]
    },
    {
      "title": "Interior",
      "points": [
        "Seats (fading, scratches, tears, bad cushion, etc.)",
        "Carpet (rips, holes, or fades, etc.)",
        "Dashboard (scratches, fading, etc.)",
        "Window functionality (stuck and cranks)",
        "All Door handles",
        "All Door locks",
        "Horn",
        "Working audio system",
        "Windshield Wipers",
        "Convertible Top",
      ]
    },
    {
      "title": "Engine bay",
      "points": [
        "Oil (level, color, etc.)",
        "Coolant (level, color, etc.)",
        "Brake Fluid (level, color, etc.)",
        "Power Steering Fluid (level, color, etc.)",
        "Battery (record date)",
        "Belts",
        "AC components (Note if components are missing)",
        "Fuel filter",
        "Notcieable leaks",
        "Hood hinges",
        "Overall cleanliness and condition",
      ]
    },
    {
      "title": "Road test",
      "points": [
        "Engine Starts Properly (note sticking and grinding)",
        "Engine Idles Performance While Cold",
        "Ticking or noises while cold idle",
        "Battery and alternator test (record percent or voltage)",
        "Smooth shifting into gear",
        "Ticking or noises while driving",
        "Cluctch firmness (if applicable)",
        "Brakes feel firm and pedal resistance",
        "Steering feels centered and free of play",
        "Fuel guage",
        "Speedometer",
        "Tachometer",
        "Temperature guage",
        "Oil guage",
        "AC Operation (if applicable)",
        "Overheating (if temp guages goes over 210)",
        "Noises during drive (if any)",
        "Shakes, misfires, stalling",
        "Overall ride and handling",
      ]
    },
    {
      "title": "Underbody",
      "points": [
        "Frame Condition (damage, rust, cleanliness)",
        "Floorpan Condition (damage, rust, cleanliness)",
        "Exhaust System Condition (damage, rust, cleanliness)",
        "Bushings and Ball Joints (damage, rust, cleanliness)",
        "Tranmission leaks",
        "Oil leaks (filter or pan)",
        "Gas tank condition",
        "Rear/differential leaks",
        "Overall condition",
      ]
    }
  ];